import React, { useEffect } from "react";
import { Nav } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { TaxonomyType } from "../../../models/taxonomy-model";
import { retrieveTaxonomy } from "../../../redux/slice/taxonomy-slice";
import { RootState, useAppDispatch } from "../../../redux/store";

const TaxonomyTrail = (props: { detailPageTaxonomy: TaxonomyType[] | undefined, addSchema?: boolean }) => {
  const dispatch = useAppDispatch();
  const { data } = useSelector((state: RootState) => state.taxonomyList);

  useEffect(() => {
    dispatch(retrieveTaxonomy());
  }, [dispatch]);

  return (
    <>
      <h4>Discover more of what matters to you</h4>
      {props.detailPageTaxonomy !== undefined ? (
        <div className="sectors">
          {props.detailPageTaxonomy?.length > 0 ? (
            props.detailPageTaxonomy?.map((item, index) => {
              return (<React.Fragment key={index}>
                {props.addSchema && <><span itemScope={true} itemProp="keywords" itemType="https://schema.org/DefinedTerm">
                  <Nav.Link href={`/search?taxonomy=${item.taxonomyId}`} className="btn btn-plain">
                    <span itemProp="name">{item.categoryName}</span>
                  </Nav.Link>
                </span></>}
                {!props.addSchema && <>
                  <Nav.Link href={`/search?taxonomy=${item.taxonomyId}`} className="btn btn-plain">
                    {item.categoryName}
                  </Nav.Link>
                </>}
              </React.Fragment>);
            })
          ) : (
            <div className="sectors text-left">No taxonomy</div>
          )}
        </div>
      ) : (
        <div className="sectors">
          {data?.length > 0 ? (
            data?.map((item, index) => {
              return (
                <Nav.Link key={index} href={`/search?taxonomy=${item.taxonomyId}`} className="btn btn-plain">
                  {item.categoryName}
                </Nav.Link>
              );
            })
          ) : (
            <div className="sectors text-left">No taxonomy</div>
          )}
        </div>
      )}
    </>
  );
};

export default TaxonomyTrail;
